import { LIST_BRANDS_HIDDEN_FROM_DESCRIPTION } from '~/src/context/Common/commonHeader';
export const PACK_SIZE_CHANGE = 'pack size change';
export const PACK_QUANTITY_CHANGE = 'pack quantity change';
export const UPDATE_PRODUCT = 'change product';

export const changeQuantity = (dispatch) => (quantity, id) => dispatch({ type: PACK_QUANTITY_CHANGE, id, quantity });
export const setPackSize = (dispatch) => (id) => dispatch({ type: PACK_SIZE_CHANGE, id });

export const updateProduct = (dispatch) => (productDetails) => {
  dispatch({
    type: UPDATE_PRODUCT,
    payload: {
      base_img_url: productDetails?.base_img_url,
      packSize: productDetails?.children,
      packSelected: productDetails?.children?.[0],
      isCosmetic: productDetails?.isCosmetic,
      isComboAvailable: productDetails?.isComboAvailable,
      visibility: productDetails?.visibility,
      hideBrandNameForParticularBrand: LIST_BRANDS_HIDDEN_FROM_DESCRIPTION.includes(productDetails?.external_entity?.toLowerCase()),
    },
  });
};
